





















































































































































import { Component } from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs} from "wings-ui-components";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";
import BaseItemsPage from '@/pages/Pages/BaseItemsPage';
import {MailNotifyGroupItem} from '@/store/mail_notify/statistic/types';
import {dateFilter} from "@/utils/date-util";
import MNGroupFilter from "@/components/MailNotify/Statistic/MNGroupFilter.vue";

@Component({
  components: {MNGroupFilter, Tabs, GroupCharts},
  filters: {dateFilter}
})
export default class MNGroup extends BaseItemsPage<MailNotifyGroupItem> {

  @Getter("mailNotifyStatisticGroup") responseItems!: MailNotifyGroupItem[];

  is_show_filter = true;
  is_show_graphics = true;

  currentSort= "message_category";
  currentSortOrder= "desc";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  get tableFieldsDefault() {
    let priceFields = ['partner_price', 'provider_price'];
    return [
      ...['transmitted', 'delivered', 'read', 'not_delivered', 'expired', 'failed', 'rejected', 'deferred', 'total'],
      ...(this.isShowFinanceInfo ? priceFields : []),
    ]
  }

  getFieldName(name: string) {
    if (name == 'partner_price') return 'income'
    if (name == 'provider_price') return 'rate'
    return name
  }

  getData(): MailNotifyGroupItem[] {
    return this.responseItems;
  }

  get isShowFinanceInfo(): boolean {
    let value: string = localStorage.getItem("show-finance-info") || "true";
    return JSON.parse(value)
  }

  get totalData(): MailNotifyGroupItem {
    let total = {
      totalRow: "This is the last row of the table",
      transmitted: 0,
      delivered: 0,
      not_delivered: 0,
      expired: 0,
      failed: 0,
      read: 0,
      rejected: 0,
      deferred: 0,
      total: 0,
      partner_price: '0',
      provider_price: '0',
    };
    this.tableData.forEach((row) => {
      total.transmitted += row.transmitted;
      total.delivered += row.delivered;
      total.not_delivered += row.not_delivered;
      total.expired += row.expired;
      total.failed += row.failed;
      total.read += row.read;
      total.rejected += row.rejected;
      total.deferred += row.deferred;
      total.total += row.total;
      total.partner_price = String((Number(row.partner_price) + Number(total.partner_price)).toFixed(4));
      total.provider_price = String((Number(row.provider_price) + Number(total.provider_price)).toFixed(4));
    });
    return total;
  }

  get campareData():any[] {
    return [...this.queriedData, this.totalData]
  }
}
